import cookie from "cookie";
import querystring from "querystring";
import { useEffect, useState } from "react";

export const getReferrerFromCookie: () => string | undefined = () => {
  try {
    const landingParamsCookie = cookie.parse(document.cookie)["landing-params"];
    const landingParams = querystring.parse(landingParamsCookie);
    return landingParams.referrer as string;
  } catch (_) {
    return undefined;
  }
};

export const useReferrerFromCookie: () => string | undefined = () => {
  const [landingParams, setLandingParams] = useState<string | undefined>();
  useEffect(() => {
    setLandingParams(getReferrerFromCookie());
  });
  return landingParams;
};

export const getQueryParamFromPath = (url: string, query: string) => {
  const urlParams = new URLSearchParams(url);

  return urlParams.has(query) ? urlParams.get(query) : "";
};

export const setLandingParams = (embedded?: boolean) => {
  // Set landing-params cookie
  if (typeof window !== "undefined") {
    const path = window.location.search;

    if (path) {
      // set expiry date to 30 minutes from now
      const expiryDate = new Date(60 * 1000 * 30 + Date.now()).toUTCString();
      const query = encodeURIComponent(
        path.replace(/^\?/, ""),
      );
      const sameSite = embedded ? "None" : "Strict";
      const secure = embedded ? "Secure;" : "";
      const isLocal = window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1";
      document.cookie = `landing-params=${query};path=/;${isLocal ? "" : `domain=.${DOMAIN}`};expires=${expiryDate};SameSite=${sameSite};${secure}`;

      if (getQueryParamFromPath(path, "ff1") === "true") {
        window.sessionStorage.setItem("forceFf1", "true");
      }
    }
  }
};
